import { useEffect, useState } from "react";
import { NavLink, Link as RouterLink } from "react-router-dom";
// @mui
import { Button, Stack, Typography, Link, CircularProgress } from "@mui/material";
import { AccessTime, Moped, Place, ReceiptLong, Storefront } from "@mui/icons-material";
//
import useResponsive from "../hooks/useResponsive";
import useAppContext from "src/hooks/useAppContext";
import { PATHS } from "src/routes/paths";

const GAP_DELIVERY_TIME = 20;

function formatHour(hour) {
  if (Number.isInteger(Number(hour)))
    return `${hour}h`;

  const h = Math.trunc(hour);
  const m = (hour % h) * 60;

  return `${h}h${parseInt(m)}`
}

export default function Welcome() {
  const [loading, setLoading] = useState(true);

  const { deliveryStatus, givenTime } = useAppContext();

  const isDesktop = useResponsive('up', 'md');

  useEffect(() => {
    if (deliveryStatus)
      setLoading(false);
  }, [deliveryStatus])

  return (
    <>
      <div style={{ position: 'fixed', backgroundImage: 'url("bg.jpg")', height: '100vh', width: '100vw', filter: 'brightness(30%)' }} />

      <Stack direction={'column'} alignItems={'center'} sx={{ pt: 5, zIndex: 2, position: 'relative' }}>
        {!isDesktop &&
          <img src="logo.jpg" width={100} height={100} alt='' style={{ margin: '8px auto' }} />
        }

        {loading &&
          <CircularProgress />
        }

        {!loading && deliveryStatus?.open &&
          <Button
            size="lg"
            variant="contained"
            component={NavLink}
            to={PATHS.menu}
            startIcon={<ReceiptLong />}
            sx={{ mt: 3 }}
          >
            Faça seu pedido
          </Button>
        }

        {!loading && !deliveryStatus?.open &&
          <Typography variant="h6" textAlign={'center'}>
            Ops! Estamos fechados no momento! <br />
            <Link to={'/horarios'} component={RouterLink}>Confira aqui</Link> os horários de funcionamento.
          </Typography>
        }

        {/* <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
          <Phone sx={{ mr: 1 }} />
          (27) 9 9779-1499
        </Typography> */}

        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
          <Place sx={{ mr: 1 }} />
          Ponto Alto, Domingos Martins
        </Typography>

        <Typography textAlign={'center'} sx={{ display: 'flex', alignItems: { xs: 'initial', sm: 'center' }, justifyContent: 'center', mt: 3, width: '90%' }}>
          <Moped sx={{ mr: 1 }} />
          Tempo estimado de entrega: entre {givenTime} a {givenTime + GAP_DELIVERY_TIME} minutos
        </Typography>

        <Typography textAlign={'center'} sx={{ display: 'flex', alignItems: { xs: 'initial', sm: 'center' }, justifyContent: 'center', width: '90%' }}>
          <Storefront sx={{ mr: 1 }} />
          Tempo estimado para retirada: entre {givenTime} a {givenTime + GAP_DELIVERY_TIME} minutos
        </Typography>

        {deliveryStatus?.open &&
          <Typography sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
            <AccessTime sx={{ mr: 1 }} />
            Horário de funcionamento hoje: {formatHour(deliveryStatus?.start)} às {formatHour(deliveryStatus?.end)}
          </Typography>
        }

        {deliveryStatus?.open &&
          <Link to={'/horarios'} component={RouterLink} sx={{ mt: 2 }}>
            Confira os horários de funcionamento
          </Link>
        }
      </Stack>
    </>
  )
}